import { FC, useState } from 'react';

import {
  PossibleFilters,
  AuditAllFilters,
  AuditStateFilterItem,
  AuditSelectedFilters,
  FilterFetch,
} from '@restore/auditTrailsFilters/auditFilters.types';
import { Filter } from '@dynamika-shared/ui/icons';

import {
  CustomDropdownProps,
  Dropdown,
} from '@dynamika-shared/ui/Dropdown/Dropdown';
import { SubChips } from './SubChips';

export type ToggleSelectedFilters = {
  name: PossibleFilters;
  value: string;
};

export type ChipsFilterProps = CustomDropdownProps & {
  subFilters: [PossibleFilters, AuditStateFilterItem][];
  allFilters: AuditAllFilters;
  selectedFilters: AuditSelectedFilters;
  closeTag: (name: PossibleFilters) => void;
  toggleSelectedFilter: ({ name, value }: ToggleSelectedFilters) => void;
  setActionBySearch: (value: string) => void;
  setSearch: (value: string) => void;
  setEventSearch: (value: string) => void;
  actionBySearch: string;
  search: string;
  eventSearch: string;
  filtersFetch: ({ patientCode, actionBy, event }: FilterFetch) => void;
  showSubFilters: boolean;
};

export const ChipsFilter: FC<ChipsFilterProps> = props => {
  const {
    closeTag,
    allFilters,
    selectedFilters,
    toggleSelectedFilter,
    setActionBySearch,
    setSearch,
    setEventSearch,
    actionBySearch,
    search,
    eventSearch,
    filtersFetch,
    showSubFilters = true,
    ...otherProps
  } = props;
  const [visible, setVisible] = useState<boolean>();

  return (
    <div className='filter-container flex flex-wrap items-start gap-[12px] shrink-0'>
      <div
        className={
          'flex flex-wrap items-center justify-end gap-[12px] max-w-[56rem]'
        }
      >
        {showSubFilters && (
          <SubChips
            subFilters={props.subFilters}
            allFilters={allFilters}
            actionBySearch={actionBySearch}
            selectedFilters={selectedFilters}
            search={search}
            eventSearch={eventSearch}
            closeTag={closeTag}
            setSearch={setSearch}
            setEventSearch={setEventSearch}
            filtersFetch={filtersFetch}
            setActionBySearch={setActionBySearch}
            toggleSelectedFilter={toggleSelectedFilter}
          />
        )}
      </div>
      <div
        role='button'
        className='hover:bg-waterLight flex h-[4rem] cursor-pointer items-center rounded-md'
      >
        <Dropdown
          {...otherProps}
          trigger={['click']}
          open={visible}
          className='h-full p-1'
          onOpenChange={(_, { source }) => {
            if (source === 'trigger') setVisible(!visible);
          }}
        >
          <div className='flex items-center justify-center gap-1'>
            <Filter height={20} width={20} />
            <div className='text-1424'>Filter</div>
          </div>
        </Dropdown>
      </div>
    </div>
  );
};
